"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Button = _interopRequireDefault(require("./Button.js"));
var _Flex = _interopRequireDefault(require("./Flex.js"));
var _String = _interopRequireDefault(require("./String.js"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Loading error component
 *
 * Use when an error occurred while loading content.
 * 
 * @package HOPS
 * @subpackage Components
 * @author Heron Web Ltd
 * @copyright Heritage Operations Processing Limited
 */class LoadingError extends _react.default.PureComponent {
  /**
   * Render.
   * 
   * @return {ReactNode}
   */
  render() {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Flex.default, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_String.default, {
        color: "textSecondary",
        str: this.props.message || "Error loading content."
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Flex.default, {
        alignItems: "flex-start",
        children: this.props.onRetry && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
          label: "Retry",
          onClick: this.props.onRetry,
          variant: "outlined"
        })
      })]
    });
  }
}
var _default = exports.default = LoadingError;